import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { en, kr, jp } from './'

const languages = { en, kr, jp }

export default function translate(key) {
  return Component => {

    const stateToProps = state => ({
        user: state.user
    })

    class TranslationComponent extends React.Component {

      render() {
//        console.log('translate', this.props)
        const strings = languages[this.props.user.lang][key]
        if (!strings) {
          console.log('[translate] string object not found, lang: '+this.props.user.lang + ', key: '+key)
          return <Component {...this.props} />
        }

        const merged = {
          ...this.props.strings,
          ...strings
        }
        return (<Component {...this.props} strings={merged} />)
      }
    }

    TranslationComponent.propTypes = {
      strings: PropTypes.object,
      language: PropTypes.string
    }

    return connect(stateToProps)(TranslationComponent)
  }
}



// WEBPACK FOOTER //
// ./src/i18n/Translate.js